module.exports = "/fonts/opensansextrabolditalic.woff";